/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TreatmentInstruction } from '../../models/treatment-instruction';

export interface GetByArticleIdTreatmentIds$Params {

/**
 * Ids of the treatment to fetch instructions.
 */
  treatmentIds?: Array<string>;
  articleId?: string;
}

export function getByArticleIdTreatmentIds(http: HttpClient, rootUrl: string, params?: GetByArticleIdTreatmentIds$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TreatmentInstruction>>> {
  const rb = new RequestBuilder(rootUrl, getByArticleIdTreatmentIds.PATH, 'get');
  if (params) {
    rb.query('treatmentIds', params.treatmentIds, {});
    rb.query('articleId', params.articleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TreatmentInstruction>>;
    })
  );
}

getByArticleIdTreatmentIds.PATH = '/api/mh/treatment-instruction';
